import React from 'react';
import { useReveal } from '../lib/useReveal';
export function FinalCTASection() {
  const [ref, vis] = useReveal();
  return <section id="cta" className="bg-[#11152e] py-6 md:py-12 px-4 sm:px-6 border-t border-[#ffffff]/5" data-id="element-74">
      <div className="container mx-auto max-w-3xl" data-id="element-75">
        <div ref={ref} className={`reveal text-center ${vis ? 'is-visible' : ''}`} data-id="element-76">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6] mb-5" data-id="element-77">
            COMENZÁ HOY TU FORMACIÓN EN{' '}
            <span className="text-[#d4af37] italic" data-id="element-78">ASTROLOGÍA</span>
          </h2>

          <p className="text-[#cbd0e0] text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-4 font-medium" data-id="element-79">
            Descubrí el lenguaje de los astros y aprendé a interpretar cartas
            natales de forma clara, práctica y profesional.
          </p>
          <p className="text-[#cbd0e0] text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-80">
            Comprendé talentos, desafíos, relaciones, vocación y propósito desde
            una mirada profunda y transformadora.
          </p>

          <a href="#pricing" className="inline-block w-full sm:w-auto px-10 py-5 rounded-xl text-[#0a0e1f] font-bold text-base md:text-lg tracking-widest uppercase transition-all shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:shadow-[0_14px_32px_rgba(212,175,55,0.35)] hover:-translate-y-1 bg-[#d4af37] hover:bg-[#c19b2e]" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-81">
            👉 QUIERO COMENZAR AHORA
          </a>

          <p className="text-[#8b91ad] text-xs sm:text-sm mt-6 font-bold" data-id="element-82">
            🛡️ Garantía de satisfacción 7 días · 🔒 Pago seguro · ⚡ Acceso
            inmediato
          </p>

          <div className="mt-12 pt-8 border-t border-[#ffffff]/10" data-id="element-83">
            <p className="text-[#8b91ad] text-xs md:text-sm font-bold tracking-[0.3em] uppercase" data-id="element-84">
              Academia Holística Argentina
            </p>
          </div>
        </div>
      </div>
    </section>;
}